<template>
    <form class="el-form" :class="[labelPosition ? 'el-form--label-' + labelPosition : '', { 'el-form--inline': inline }]">
        <slot></slot>
    </form>
</template>
<script>
import objectAssign from 'element-ui/lib/utils/merge';

export default {
    name: 'XxForm',

    componentName: 'ElForm',

    provide() {
        return {
            elForm: this
        };
    },

    props: {
        model: Object,
        rules: Object,
        labelPosition: String,
        labelWidth: String,
        labelSuffix: {
            type: String,
            default: ''
        },
        inline: Boolean,
        inlineMessage: Boolean,
        statusIcon: Boolean,
        showMessage: {
            type: Boolean,
            default: true
        },
        size: String,
        disabled: Boolean,
        validateOnRuleChange: {
            type: Boolean,
            default: true
        },
        extraData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        toastMessage: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        _labelWidth() {
            return this.labelWidth || (this.$xxConfig || {}).formLabelWidth;
        }
    },
    watch: {
        rules() {
            this.$nextTick(() => {
                this.fields.forEach(item => item.initRulesValidate());
            });
            if (this.validateOnRuleChange) {
                this.validate(() => {});
            }
        }
    },
    data() {
        return {
            fields: []
        };
    },
    created() {
        this.$on('el.form.addField', field => {
            if (field) {
                this.fields.push(field);
            }
        });
        /* istanbul ignore next */
        this.$on('el.form.removeField', field => {
            if (field.prop) {
                this.fields.splice(this.fields.indexOf(field), 1);
            }
        });
    },
    methods: {
        resetFields() {
            if (!this.model) {
                process.env.NODE_ENV !== 'production' && console.warn('[Element Warn][Form]model is required for resetFields to work.');
                return;
            }
            this.fields.forEach(field => {
                field.resetField();
            });
        },
        clearValidate(props = []) {
            const fields = props.length ? this.fields.filter(field => props.indexOf(field.prop) > -1) : this.fields;
            fields.forEach(field => {
                field.clearValidate();
            });
        },
        validate(callback, props) {
            if (!this.model) {
                console.warn('[Element Warn][Form]model is required for validate to work!');
                return;
            }
            // 如果传入了数组，认为传入的是props
            if (Array.isArray(callback) && !props) {
                props = callback;
                callback = undefined;
            }

            let promise;
            const msgBuffer = [];
            // if no callback, return promise
            if (typeof callback !== 'function' && window.Promise) {
                promise = new window.Promise((resolve, reject) => {
                    callback = function(valid) {
                        valid ? resolve(valid) : reject({ valid, result: msgBuffer });
                    };
                });
            }

            let valid = true;
            let count = 0;
            // 如果需要验证的fields为空，调用验证时立刻返回callback
            if (this.fields.length === 0 && callback) {
                callback(true);
            }
            let firstErrorFields;
            let invalidFields = {};
            const fields = props ? this.fields.filter(field => {
                return props.includes(field.prop);
            }) : this.fields;
            fields.forEach(field => {
                field.validate('', (message, field) => {
                    if (message) {
                        if (!firstErrorFields) {
                            firstErrorFields = field;
                        }
                        valid = false;
                    }
                    msgBuffer.push({ message, field });
                    invalidFields = objectAssign({}, invalidFields, field);
                    if (typeof callback === 'function' && ++count === fields.length) {
                        callback(valid, invalidFields, msgBuffer);
                    }
                });
            });

            if (promise) {
                return promise.catch(e => {
                    if (this.toastMessage) {
                        const message = msgBuffer.find(item => item.message);
                        this.$message.warning(message || '校验不通过');
                    }
                    return Promise.reject(e);
                });
            }
        },
        validateField(prop, cb) {
            let field = this.fields.filter(field => field.prop === prop)[0];
            if (!field) {
                throw new Error('must call validateField with valid prop string!');
            }
            field.validate('', cb);
        }
    }
};
</script>
